import { render, staticRenderFns } from "./UpstreamAndDownstreamRisk.vue?vue&type=template&id=4fb8953b&scoped=true"
import script from "./UpstreamAndDownstreamRisk.vue?vue&type=script&lang=js"
export * from "./UpstreamAndDownstreamRisk.vue?vue&type=script&lang=js"
import style0 from "./UpstreamAndDownstreamRisk.vue?vue&type=style&index=0&id=4fb8953b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb8953b",
  null
  
)

export default component.exports